import { TreeItem } from '@mui/x-tree-view';
import { Checkbox, Stack, Typography } from '@mui/material';
import React, { useCallback, useMemo } from 'react';

import { HBSelectTreeDataProps } from './HBSelectTree';

export type HBSelectTreeItemProps = {
  tree: HBSelectTreeDataProps[];
  onClick?: (item: HBSelectTreeDataProps, event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedIds?: string[];
  defaultCollapseIcon: any;
  defaultExpandIcon: any;
};

export default function HBSelectTreeItem({
  tree = [],
  selectedIds = [],
  onClick,
  defaultCollapseIcon,
  defaultExpandIcon,
}: HBSelectTreeItemProps): JSX.Element {
  const handleCheckChecked = useCallback(
    (item: HBSelectTreeDataProps): boolean => {
      return selectedIds.includes(item.id);
    },
    [selectedIds],
  );

  const getIndeterminateState: (item: HBSelectTreeDataProps) => boolean = (item) => {
    const children = item.children || [];
    const selectedChildren = children.filter((f) => selectedIds.includes(f.id));

    if (selectedChildren.length > 0 && selectedChildren.length < children.length) {
      return true;
    }
    if (item.children?.length) {
      return item.children?.some((item: HBSelectTreeDataProps) => getIndeterminateState(item));
    }
    return false;
  };

  const updatedTree = useMemo(() => {
    return tree;
  }, [tree, selectedIds]);

  return (
    <>
      {updatedTree.map((item) => {
        const isSelectable = item.selectable || item.isAllocatableToProduct;
        return (
          <TreeItem
            key={item.id}
            label={
              <Stack direction="row" alignItems="center">
                {isSelectable && (
                  <Checkbox
                    checked={handleCheckChecked(item)}
                    indeterminate={getIndeterminateState(item)}
                    onChange={(event) => {
                      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                      onClick && onClick(item, event);
                    }}
                    value={item.id}
                    sx={{ p: 0, ml: 0 }}
                  />
                )}

                {selectedIds.includes(item.id)}
                <Typography variant="subtitle2" sx={{ pl: 1 }}>
                  {item.label}
                </Typography>
              </Stack>
            }
            itemId={item.id}
            sx={{ minWidth: 100 }}
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            {item.children && item.children.length > 0 && (
              <HBSelectTreeItem
                defaultCollapseIcon={defaultCollapseIcon}
                defaultExpandIcon={defaultExpandIcon}
                tree={item.children}
                onClick={onClick}
                selectedIds={selectedIds}
              />
            )}
          </TreeItem>
        );
      })}
    </>
  );
}
